import React from 'react'
import { useSelector } from 'react-redux'
import { getSessionPersistSelector } from '../store/sessionPersist.selectors'

const SessionPersistGate: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { showModal } = useSelector(getSessionPersistSelector)

  return (
    <div
      id='session-persist-gate'
      style={{
        visibility: showModal ? 'hidden' : 'visible',
        height: '100%',
        display: 'contents',
      }}>
      {children}
    </div>
  )
}

export default SessionPersistGate
